// extracted by mini-css-extract-plugin
export default {"customized-column-width":"HoldPeriodResale_customized-column-width__ro-T1"};